import { createStore, applyMiddleware } from 'redux';
import { createLogger } from 'redux-logger';
import domReady from './domReady';

import { RootReducer } from '../../reducers/Root';
import Test from '../Test';
import Trash from '../Trash';
import PostActionMessages from '../Messages';
import Settings from '../Settings';
import Trial from '../Trial';

import Config from './config';

const initialState = {};

const createStoreWithMiddleware = applyMiddleware(createLogger())(createStore);
const store = createStoreWithMiddleware(
  RootReducer,
  initialState,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);

const config = new Config(store);

window.store = store;
window.config = config;

domReady(() => {
  new Test('.test', store);
  new Trash('#trash', store);
  new PostActionMessages('#pam-area', store);
  new Settings('#nav-overlay', store);
  new Trial('#trial-days', store);
});
